import { render } from "./section-total-ticket-based-range-time.vue?vue&type=template&id=c48f7140&ts=true"
import script from "./section-total-ticket-based-range-time.vue?vue&type=script&lang=ts"
export * from "./section-total-ticket-based-range-time.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__